import { createAction, props } from '@ngrx/store';

export const setMineralLegalNoticeVisibility = createAction(
  '[Mineral] Set mineral legal notice visibility',
  props<{ visible: boolean }>(),
);
